
import paginate from 'jw-paginate'
import Vue from 'vue'
import RPHPaginationButton from 'rph/atoms/RPHPaginationButton/index.vue'
import { paginationEnums } from '~/enums/paginationEnums'
export default Vue.extend({
  name: 'RPHPagination',
  components: { RPHPaginationButton },
  props: {
    /**
     * total available pages
     */
    totalPages: {
      type: [String, Number],
      required: true,
    },
    pageItems: {
      type: [String, Number],
      required: true,
    },
    totalItems: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      currentPage: +this.$route.query.page || 1,
      width: this.window?.screen.width,
    }
  },
  computed: {
    countToShow() {
      return this.width < 780 ? 3 : 7
    },
    desktopPages() {
      let paginationPages = paginate(
        this.totalItems,
        this.currentPage,
        this.pageItems,
        this.countToShow,
      )
      if (paginationPages.totalPages <= 9) return paginationPages.totalPages

      if (paginationPages.startPage >= 3) {
        paginationPages.pages.unshift(paginationEnums.dots)
      }

      if (paginationPages.pages[0] !== 1) paginationPages.pages.unshift(1)

      if (paginationPages.endPage + 2 <= paginationPages.totalPages)
        paginationPages.pages.push(paginationEnums.dots)

      if (paginationPages.pages[paginationPages.pages.length - 1] !== paginationPages.totalPages) {
        paginationPages.pages.push(paginationPages.totalPages)
      }
      return paginationPages.pages
    },
    mobilePages() {
      let paginationPages = paginate(
        this.totalItems,
        this.currentPage,
        this.pageItems,
        this.countToShow,
      )
      if (paginationPages.totalPages <= 7) return paginationPages.totalPages

      if (paginationPages.startPage >= 3) {
        paginationPages.pages.unshift(paginationEnums.dots)
      }

      if (paginationPages.pages[0] !== 1) paginationPages.pages.unshift(1)

      if (paginationPages.endPage + 2 <= paginationPages.totalPages)
        paginationPages.pages.push(paginationEnums.dots)

      if (paginationPages.pages[paginationPages.pages.length - 1] !== paginationPages.totalPages) {
        paginationPages.pages.push(paginationPages.totalPages)
      }
      return paginationPages.pages
    },
  },
  watch: {
    $route() {
      this.currentPage = +this.$route.query.page || 1
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.width = window.innerWidth
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth
    },
  },
})
